// Bootstrap import: initializes i18next and resolves the stored/browser locale.
import './config';
import { setLanguage, getInitialLocale } from './config';

// Fire-and-forget bootstrap; react-i18next useSuspense:false renders with
// fallback/⚠keys until bundles land.
// (2026-10-11) setLanguage is now failure-isolated per namespace chunk and
// re-registers late bundles with a languageChanged re-render signal, so a
// transient import failure can no longer leave a namespace (e.g. 'auth' on
// /login) permanently raw. The bootstrap promise is explicitly caught so an
// unexpected rejection is never an unhandled rejection.
void setLanguage(getInitialLocale()).catch(() => { /* best-effort bootstrap; per-namespace failures are isolated */ });

export * from './config';
